// extracted by mini-css-extract-plugin
export default {"m":"_2565d6e03b","title":"d3cc1fd307","feedback_inner_title":"_8f8da6f584","textarea":"_287922ff0d","radio":"_39dc26696b","text":"_3b7b765955"};